module.exports = __webpack_public_path__ + "img/portrait-101.76370115.jpg";